﻿import type { DeviceStatusLogItem } from "@/types.ts";
import { formatDateTime } from "@/lib/format";
import { AdminTable, AdminTd, AdminTr } from "@/components/admin";
interface StatusLogCardProps {
    selectedDeviceId: number | null;
    logs: DeviceStatusLogItem[];
}
const StatusLogCard = ({ selectedDeviceId, logs }: StatusLogCardProps) => {
    return (<div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-history-line text-blue-500 text-sm"/>
          <h3 className="text-sm font-semibold text-slate-800">상태 로그</h3>
        </div>
        <span className="text-xs text-slate-400">{logs.length}건 기록</span>
      </div>

      <div className="max-h-72 overflow-y-auto">
        {!selectedDeviceId || logs.length === 0 ? (<div className="px-4 py-6 text-center">
            <p className="text-xs text-slate-400">
              {selectedDeviceId ? "표시할 상태 로그가 없습니다." : "기기를 선택하면 상태 로그가 표시됩니다."}
            </p>
          </div>) : (<AdminTable headers={["기록 시각", "배터리", "네트워크", "앱"]}>
              {logs.slice(0, 8).map((log) => (<AdminTr key={log.deviceStatusLogId} className="hover:bg-slate-50">
                  <AdminTd className="whitespace-nowrap text-xs text-slate-500">{formatDateTime(log.recordedAt)}</AdminTd>
                  <AdminTd className="text-xs font-medium text-slate-700">
                    {log.batteryLevel == null ? "-" : `${log.batteryLevel}%`}
                  </AdminTd>
                  <AdminTd className="text-xs text-slate-600">{log.networkStatus}</AdminTd>
                  <AdminTd className="text-xs text-slate-600">{log.appStatus}</AdminTd>
                </AdminTr>))}
          </AdminTable>)}
      </div>
    </div>);
};
export default StatusLogCard;
